import moment from 'moment-timezone';
import { StatusCb8Enum, WeekDayEnum, type AvailabilityPeriod } from 'types/swagger';

import SyncStatus from '../constants/SyncStatus';

export const parseStartPeriod = (startPeriod: string) => {
  let days = 0;
  let seconds = 0;
  if (startPeriod.includes(' ')) {
    const splitDays = startPeriod.split(' ');
    days = parseInt(splitDays[0]);
    seconds = splitDays[1].split(':').reduce((acc, curr, i) => {
      return acc + parseInt(curr) * Math.pow(60, 2 - i);
    }, 0);
  }
  seconds = startPeriod.split(':').reduce((acc, curr, i) => {
    return acc + parseInt(curr) * Math.pow(60, 2 - i);
  }, 0);
  return { days, seconds };
};

export const isChargePointOnline = (chargePoint: { status: StatusCb8Enum | undefined }) => {
  return chargePoint.status === StatusCb8Enum.Online;
};

export const chargePointHasAccess = (
  availabilityPeriods: Record<WeekDayEnum, AvailabilityPeriod[]>
) => {
  if (!availabilityPeriods || !Object.values(availabilityPeriods).length) return false;
  const now = moment.utc();
  const dayStart = moment.utc().startOf('day');
  const filteredPeriods: AvailabilityPeriod[] = [];
  if (availabilityPeriods[WeekDayEnum.Value0])
    filteredPeriods.push(...availabilityPeriods[WeekDayEnum.Value0]);
  if (availabilityPeriods[now.day() as WeekDayEnum])
    filteredPeriods.push(...availabilityPeriods[now.day() as WeekDayEnum]);
  if (!filteredPeriods?.length) return false;
  const currentPeriod = filteredPeriods.reduce((acc, curr) => {
    if (!acc) return curr;
    const accStartPeriod = parseStartPeriod(acc.start_period);
    const currStartPeriod = parseStartPeriod(curr.start_period);
    const accStart = dayStart
      .clone()
      .add(accStartPeriod.days, 'days')
      .add(accStartPeriod.seconds, 'seconds');
    const currStart = dayStart
      .clone()
      .add(currStartPeriod.days, 'days')
      .add(currStartPeriod.seconds, 'seconds');
    if (now.isSameOrAfter(accStart) && now.isBefore(currStart)) return acc;
    return curr;
  });
  return currentPeriod.with_access;
};

export const ChargingProfileDesyncStatuses = [SyncStatus.REJECTED, SyncStatus.NOT_SUPPORTED, null];
